var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"50px"}},[_vm._v(" Страница не найдена"),_c('br'),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Вернуться на главную")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }